import { gql } from 'graphql-request';
import {
  CacheStatus,
  Nullable,
  UserWithToken,
  WithData,
} from '@ygoargentina/sdk/api/api.types';
import { getGraphQLQueryClient } from './query-client';

export const getCacheStatus = (user: Nullable<UserWithToken>) =>
  getGraphQLQueryClient(user).request<WithData<CacheStatus>>(gql`
    query cacheStatus {
      data: cacheStatus {
        enabled
        totalSize
        caches {
          key
          ttl
          description
          totalSize
          entryCount
          entries {
            key
            size
            expiresAt
            createdAt
          }
        }
      }
    }
  `);

export const clearCache = (user: Nullable<UserWithToken>, key: string) =>
  getGraphQLQueryClient(user).request<WithData<boolean>>(
    gql`
      mutation clearCache($key: String!) {
        data: clearCache(key: $key)
      }
    `,
    { key }
  );
